module.exports = __webpack_public_path__ + "static/media/use_graph02_ch02.43a5f3fd.jpg";